import RandingStyle1 from "../../randing/RandingStyle1";

function Randing021({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/021/01_241120_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/021/01_241120_02.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/021/02_241120_02.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="blue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/020/20241120_04.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_06.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      apiUrl={apiUrl}
    />
  );
}

export default Randing021;
